import { render, staticRenderFns } from "./RouteWarningsDialog.vue?vue&type=template&id=596e1248&scoped=true&"
import script from "./RouteWarningsDialog.vue?vue&type=script&lang=js&"
export * from "./RouteWarningsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e1248",
  null
  
)

export default component.exports